import {useTranslation} from 'react-i18next';
import * as css from './PlansStats.css';
import {useSelector} from 'react-redux';
import StatCard, {StatCardProps} from './StatCard';
import {TState} from '../../../../redux/store.type';

function PlansStats() {
    const {t} = useTranslation('subscriptions');
    const plans = useSelector((s: TState) => s.subscription?.subscriptionPlans || []);
    const totalPlans = plans.length;
    const totalEvents = plans.reduce((acc, plan) => acc + (plan.eventsCount || 0), 0);
    const stats: StatCardProps[] = [
        {
            value: totalPlans.toString(),
            label: t('totalSeries')
        },
        {
            value: totalEvents.toString(),
            label: t('totalEventsInSubscriptions')
        }
    ];
    return (
        <css.statsList>
            {stats.map((stat, index) => (
                <StatCard
                    key={index}
                    value={stat.value}
                    label={stat.label}
                    additionalInfo={stat?.additionalInfo || ''}
                />
            ))}
        </css.statsList>
    );
}

export default PlansStats;

